import { api2 } from './api'

// Returns null when there is no match: a document that does not exist is an expected outcome.
export const getTaxpayerByDocument = async ({ type, docNumber }) => {
  try {
    const response = await api2.get(`TaxPayer?type=${type}&document=${docNumber}`, {
      skipGlobalErrorDialog: true
    })
    return response?.data?.data?.consultaContribuyente ?? null
  } catch (error) {
    return null
  }
}
